import React, { useEffect, useState } from 'react';
import {
  AutocompleteComponent,
  CheckboxesComponent,
  DialogComponent,
  Spinner,
} from '../../../../../../Components';
import {
  GetAllUserSearchForShareLeads,
  ReassignLeadsAsync,
} from '../../../../../../Services/LeadXChangeServices/LeadXChangeServices';
import { useDebouncedAction } from '../../../../../../Hooks/DebouncedAction';
import { showError, showSuccess } from '../../../../../../Helper';
import { AgentRoleEnum } from '../../../../../../Enums';
import { claimTypeEnums } from '../../../Utilities/Utilities';

function LeadsXChangeReassignDialog({
  onClose,
  open,
  leadData,
  selectedIds,
  reload,
  setLoading,
}) {
  const [isLoading, setIsLoading] = useState({
    loading: false,
    updating: false,
  });
  const [allAgents, setAllAgents] = useState([]);
  const [isCopyToChecked, setisCopyToChecked] = useState(false);
  const [selectedAgent, setSelectedAgent] = useState([]);

  const getAllUserSearchForShareLeads = useDebouncedAction(async (search) => {
    setIsLoading({ loading: true, updating: false });
    const body = {
      name: search,
      userStatusId: 2,
      userTypeId: AgentRoleEnum.SaleAgent.value,
      pageIndex: 1,
      pageSize: 25,
    };
    try {
      const res = await GetAllUserSearchForShareLeads(body);
      res ? setAllAgents(res.result) : setAllAgents([]);
    } catch {
      showError('something went wrong');
    } finally {
      setIsLoading({ loading: false, updating: false });
    }
  });

  const onSubmit = async (event) => {
    event.preventDefault();
    setIsLoading({ loading: false, updating: true });
    const body = {
      sharedLeadIds: selectedIds ? selectedIds : [leadData?.sharedLeadId],
      referredToInfo: {
        userId: selectedAgent?.id,
        userName: selectedAgent?.userName,
        branchName: selectedAgent?.branchName,
        name: selectedAgent?.fullName,
      },
      claimType: claimTypeEnums.ReassignClaim,
      isCopyTo: isCopyToChecked,
    };
    try {
      await ReassignLeadsAsync(body);
      setLoading(true);
      setTimeout(() => {
        setLoading(false);
        reload();
        onClose();
        showSuccess('reassigned successfully');
      }, 4000);
    } catch {
      showError('something went wrong');
    } finally {
      setIsLoading({ loading: false, updating: false });
    }
  };

  useEffect(() => {
    getAllUserSearchForShareLeads();
  }, []);
  return (
    <DialogComponent
      saveText={'confirm'}
      saveType='button'
      maxWidth='sm'
      saveClasses='btns theme-solid w-100 mx-2 mb-2'
      isOpen={open}
      titleText={'Reassign Lead'}
      onSaveClicked={onSubmit}
      onCancelClicked={onClose}
      dialogContent={
        <>
          <div className='d-flex-column-center'>
            <Spinner
              isAbsolute
              isActive={isLoading.updating}
            />
            <AutocompleteComponent
              idRef='recommendedSchemesRef'
              labelValue='Referred To'
              data={allAgents}
              multiple={false}
              displayLabel={(option) => option?.fullName || ''}
              chipsLabel={(option) => option?.fullName || ''}
              isLoading={isLoading.loading}
              withLoader
              withoutSearchButton
              onInputKeyUp={(event) => {
                const { value } = event.target;
                getAllUserSearchForShareLeads(value);
              }}
              onChange={(e, newValue) => {
                setSelectedAgent(newValue);
              }}
            />
          </div>
          <CheckboxesComponent
            checked={isCopyToChecked}
            label='with Copy All Activites'
            wrapperClasses='mt-3'
            onSelectedCheckboxChanged={() => {
              setisCopyToChecked(!isCopyToChecked);
            }}
          />
        </>
      }
    />
  );
}

export default LeadsXChangeReassignDialog;
